import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import shortid from "shortid";

import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";

import SearchIcon from "@material-ui/icons/Search";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import { verb as proVerb } from "@language/provider";

import Container from "@material-ui/core/Container";
import Chip from "@material-ui/core/Chip";
import ButtonBase from "@material-ui/core/ButtonBase";
import useConstants from "@hooks/useConstants";

const mobile =
	"//static.tutors.com/assets/images/bg/mobile-wide/language-tutor.jpg";
const desktop =
	"//static.tutors.com/assets/images/bg/desktop/language-tutor.jpg";

const { SITE_NAME } = process.env;

const ProBannerAlternate = ({ city, state }) => {
	const { quickPickServices, header, backgroundServices, h1 } = useConstants(
		"ProBannerAlternateViewModel"
	);

	const { proSignupFunnelModalStore } = useStores();
	const classes = useStyles("Pro");
	const [backgroundImage, setBackgroundImage] = useState();

	const boxTitleOnClickHandler = (serviceName, serviceKey) =>
		proSignupFunnelModalStore.setData({
			serviceName,
			serviceKey,
		});

	useEffect(() => {
		const numberOfServices = backgroundServices.length;
		setBackgroundImage(
			backgroundServices[Math.floor(Math.random() * numberOfServices)]
		);
	}, []);

	return (
		<React.Fragment>
			<section className={classes.hero}>
				<picture className={classes.picture}>
					<source
						srcSet={`${mobile} 300w, ${mobile} 768w, ${desktop} 1280w, ${desktop} 3200w`}
						sizes="100vw"
					/>
					<img
						sizes="100vw"
						srcSet={`${mobile} 300w, ${mobile} 768w, ${desktop} 1280w, ${desktop} 3200w`}
						src={desktop}
						alt={h1}
						className={classes.backgroundImage}
						loading="lazy"
						decoding="async"
					/>
				</picture>

				<Box
					width="100%"
					left={0}
					top="50%"
					pr={2}
					pl={2}
					className={classes.heroBox}
				>
					<Container maxWidth="md">
						<Chip label="Austin, TX" />

						<Box component={"h1"} className={classes.jobsH1} color={"#FFF"}>
							Tutoring Jobs
						</Box>

						<Box component={"h2"} className={classes.jobsH2} color={"#FFF"}>
							What do you teach? We'll find you the tutoring jobs you want.
						</Box>

						<Grid container spacing={4}>
							<Grid item xs={6} sm={3}>
								<ButtonBase focusRipple className={classes.buttonBase}>
									<Box
										bgcolor={"#FFF"}
										boxShadow={6}
										borderRadius={4}
										className={classes.jobsBox}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										flexDirection={"column"}
									>
										<SearchIcon className={classes.hiwIcon} />
										<div>Math</div>
									</Box>
								</ButtonBase>
							</Grid>
							<Grid item xs={6} sm={3}>
								<ButtonBase focusRipple className={classes.buttonBase}>
									<Box
										bgcolor={"#FFF"}
										boxShadow={6}
										borderRadius={4}
										className={classes.jobsBox}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										flexDirection={"column"}
									>
										<SearchIcon className={classes.hiwIcon} />
										<div>Math</div>
									</Box>
								</ButtonBase>
							</Grid>
							<Grid item xs={6} sm={3}>
								<ButtonBase focusRipple className={classes.buttonBase}>
									<Box
										bgcolor={"#FFF"}
										boxShadow={6}
										borderRadius={4}
										className={classes.jobsBox}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										flexDirection={"column"}
									>
										<SearchIcon className={classes.hiwIcon} />
										<div>Math</div>
									</Box>
								</ButtonBase>
							</Grid>
							<Grid item xs={6} sm={3}>
								<ButtonBase focusRipple className={classes.buttonBase}>
									<Box
										bgcolor={"#FFF"}
										boxShadow={6}
										borderRadius={4}
										className={classes.jobsBox}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										flexDirection={"column"}
									>
										<SearchIcon className={classes.hiwIcon} />
										<div>Math</div>
									</Box>
								</ButtonBase>
							</Grid>
						</Grid>
					</Container>
				</Box>
			</section>

			<div className={classes.wrapper}>
				<div className={`promo category main-page ${backgroundImage}`}>
					<div className="background background--extra-light math" />
					<div className="text-frame landing container-fluid w-900">
						{city && state && (
							<div className="guide-city">
								<span>
									{city}, {state}
								</span>
							</div>
						)}

						<h1>{proVerb.singular.ucFirst()} Jobs</h1>
						<h2>{header}</h2>
						<div className="select-subject clearfix" id="pro-main-cards">
							{quickPickServices.map(({ name, key, src }) => (
								<div
									onClick={() => boxTitleOnClickHandler(name, key)}
									key={shortid.generate()}
									className="col-xs-6 col-sm-3"
								>
									<div className="subject-box">
										<img
											className="b-lazy"
											src={`//static.${SITE_NAME}.com/assets/images/bg/thumbs/default.png`}
											alt={name.ucFirst()}
											data-src={src}
										/>
										<h3>{name.ucFirst()}</h3>
									</div>
								</div>
							))}

							<a href={"/signup"} className="col-xs-6 col-sm-3">
								<div className="subject-box">
									<img
										className="b-lazy"
										src={`//static.${SITE_NAME}.com/assets/images/bg/thumbs/default.png`}
										alt={"More..."}
										data-src={`//static.${SITE_NAME}.com/assets/images/other.png`}
									/>
									<h3>{"More..."}</h3>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

ProBannerAlternate.propTypes = {
	city: PropTypes.string,
	state: PropTypes.string,
};

export default ProBannerAlternate;
